import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMapLocationDot, faPhone, faCapsules } from "@fortawesome/free-solid-svg-icons";

const farmaciasCol1 = [
  {
    nombre: "Farmacia San Cayetano",
    link: "https://maps.app.goo.gl/7AYFQYKgVZQ7xfSy7",
    direccion: (
      <>
        Belgrano 826.<br />
        <FontAwesomeIcon icon={faPhone} style={{ fontSize: "14px" }} /> 03532 - 421122<br />
      </>
    ),
  },
  {
    nombre: "Farmacia Daghero",
    link: "https://maps.app.goo.gl/Md5RVN2ABBPbeF7H9",
    direccion: (
      <>
        Pueyrredón 226.<br />
        <FontAwesomeIcon icon={faPhone} style={{ fontSize: "14px" }} /> 03532 - 411150
      </>
    ),
  },
  {
    nombre: "Farmacia Canovas",
    link: "https://maps.app.goo.gl/z6yisuqTkHnExde46",
    direccion: (
      <>
        Roque Sáenz Peña 156.<br />
        <FontAwesomeIcon icon={faPhone} style={{ fontSize: "14px" }} /> 03532 - 420578
      </>
    ),
  },
  {
    nombre: "Farmacia Del Sol",
    link: "https://maps.app.goo.gl/t7AjNJy48oqDNxfYA",
    direccion: (
      <>
        Bartolomé Mitre 127.<br />
        <FontAwesomeIcon icon={faPhone} style={{ fontSize: "14px" }} /> 03532-421978
      </>
    ),
  },
  {
    nombre: "Farmacia Issolio",
    link: "https://maps.app.goo.gl/YnFdtHbTFZwg9QQc6",
    direccion: (
      <>
        Bvard. Rodolfo Moyano 223.<br />
        <FontAwesomeIcon icon={faPhone} style={{ fontSize: "14px" }} /> 03532-421465
      </>
    ),
  },
];

const farmaciasSindical = [
  {
    nombre: "Farmacia Sindical A.T.S.A",
    link: "https://maps.app.goo.gl/c9joiiPBbdoMBtxVA",
    direccion: (
      <>
        San Lorenzo 96.<br />
        <FontAwesomeIcon icon={faPhone} style={{ fontSize: "14px" }} /> 03532 - 413970
      </>
    ),
  },
  {
    nombre: "Farmacia Sindical Oliva S.E.P",
    link: "https://maps.app.goo.gl/1v9m9g5CnjLkmKEK6",
    direccion: (
      <>
        Av. Olmos 150.<br />
        <FontAwesomeIcon icon={faPhone} style={{ fontSize: "14px" }} /> 03532 - 423092
      </>
    ),
  },
];

const farmaciasCol2 = [
  {
    nombre: "Farmacia Cuassolo de Clemente",
    link: "https://maps.app.goo.gl/4FnfhjB4cX81Xu4J6",
    direccion: (
      <>
        Belgrano – Esquina San Martin.<br />
        <FontAwesomeIcon icon={faPhone} style={{ fontSize: "14px" }} /> 03532 - 421661
      </>
    ),
  },
  {
    nombre: "Farmacia Cuassolo",
    link: "https://maps.app.goo.gl/rCNWKmFYmtw8po2R8",
    direccion: (
      <>
        Monseñor Gallardo -  Esquina Sarmiento.<br />
        <FontAwesomeIcon icon={faPhone} style={{ fontSize: "14px" }} /> 03532 - 420206<br />
      </>
    ),
  },
  {
    nombre: "Farmacia Cuassolo III",
    link: "#",
    direccion: (
      <>
        Buenos Aires – Esquina Francia .<br />
        <FontAwesomeIcon icon={faPhone} style={{ fontSize: "14px" }} /> 03532 - 422618
      </>
    ),
  },
  {
    nombre: "Farmacia Farm Salud",
    link: "https://maps.app.goo.gl/rP8eKVgJihSsMXWW8",
    direccion: (
      <>
        Bartolomé Mitre 486.<br />
        <FontAwesomeIcon icon={faPhone} style={{ fontSize: "14px" }} /> 03532-420549
      </>
    ),
  },
];

const Farmacias = () => (
  <div className="content-tab">
    <div className="row">
      <div className="col-12 col-md-6">
        <h5>
          <FontAwesomeIcon icon={faCapsules} style={{ color: "#16a085", marginRight: 8 }} />
          Farmacias
        </h5>
        <ul className="lista-referencias">
          {farmaciasCol1.map((farm, i) => (
            <li key={i}>
              <FontAwesomeIcon icon={faMapLocationDot} style={{ color: "#2980b9", marginRight: 8 }} />
              <a href={farm.link} target="_blank" rel="noopener noreferrer">
                {farm.nombre}
              </a>
              <div className="ms-2 me-auto">{farm.direccion}</div>
            </li>
          ))}
        </ul>
        <h6 style={{ marginTop: 24 }}>
          <FontAwesomeIcon icon={faCapsules} style={{ color: "#16a085", marginRight: 8 }} />
          Farmacia Sindical
        </h6>
        <ul className="lista-referencias">
          {farmaciasSindical.map((farm, i) => (
            <li key={i}>
              <FontAwesomeIcon icon={faMapLocationDot} style={{ color: "#2980b9", marginRight: 8 }} />
              <a href={farm.link} target="_blank" rel="noopener noreferrer">
                {farm.nombre}
              </a>
              <div className="ms-2 me-auto">{farm.direccion}</div>
            </li>
          ))}
        </ul>
      </div>
      <div className="col-12 col-md-6">
        <h5 style={{ visibility: "hidden", margin: 0, padding: 0 }}>Farmacias</h5>
        <ul className="lista-referencias" style={{ marginTop: 38 }}>
          {farmaciasCol2.map((farm, i) => (
            <li key={i}>
              <FontAwesomeIcon icon={faMapLocationDot} style={{ color: "#2980b9", marginRight: 8 }} />
              <a href={farm.link} target="_blank" rel="noopener noreferrer">
                {farm.nombre}
              </a>
              <div className="ms-2 me-auto">{farm.direccion}</div>
            </li>
          ))}
        </ul>
      </div>
    </div>
  </div>
);

export default Farmacias;